import { render, staticRenderFns } from "./legalPersonInfo.vue?vue&type=template&id=35711d6c&scoped=true"
import script from "./legalPersonInfo.vue?vue&type=script&lang=js"
export * from "./legalPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./legalPersonInfo.vue?vue&type=style&index=0&id=35711d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35711d6c",
  null
  
)

export default component.exports